(function () {
    'use strict';
    app.service('profileservice', ['$http', '$q', '$rootScope',
    function ($http, $q, $rootScope) {


        var serviceBase = $rootScope.buildConfig.aippsssApiBaseUrl;
        var deviceInfo = [];
        var deferred;



        this.getprofileData = function (username) {
            deferred = $q.defer();

            $http.get(serviceBase + "api/Account/user?username=" + username)
            .then(function (response) {
                deferred.resolve(response);
            })
            .catch(function (err) {
                deferred.resolve(err);
            });

            return deferred.promise;
        }

        this.getUserSubPackPurchaseDetails = function () {
            deferred = $q.defer();

            $http.get(serviceBase + "api/Account/userSubPackPurchaseDetails")
            .then(function (response) {
                deferred.resolve(response);
            })
            .catch(function (err) {
                deferred.resolve(err);
            });

            return deferred.promise;
        }

        this.getcountryData= function () {
            deferred = $q.defer();

            $http.get(serviceBase + "country")
            .then(function (response) {
                deferred.resolve(response);
            })
            .catch(function (err) {
                deferred.resolve(err);
            });

            return deferred.promise;
        }

        this.getstateData = function (AipCountryID,AipCountryCode) {
            deferred = $q.defer();

            $http.get(serviceBase + "state?AipCountryID=" + AipCountryID + "&AipCountryCode=" + AipCountryCode)
            .then(function (response) {
                deferred.resolve(response);
            })
            .catch(function (err) {
                deferred.resolve(err);
            });

            return deferred.promise;
        }


  
        this.saveProfileData = function (userRegistrationInfo) {
            deferred = $q.defer();

            $http.post(serviceBase + "api/Account/saveprofile", userRegistrationInfo, {
            }).then(function (response) {
                deferred.resolve(response);
            })
            .catch(function (err, status) {
                deferred.resolve(err);
            });
            return deferred.promise;
        }
        
        this.deactivateAccount = function () {
            deferred = $q.defer();

            $http.post(serviceBase + "api/Account/deactivateAccount", {
            }).then(function (response) {
                deferred.resolve(response);
            })
            .catch(function (err, status) {
                deferred.resolve(err);
            });
            return deferred.promise;
        }

        this.deleteRecords = function (data) {
            deferred = $q.defer();

            $http.post(serviceBase + "api/Account/deleteRecords", data, {
            }).then(function (response) {
                deferred.resolve(response);
            })
            .catch(function (err, status) {
                deferred.resolve(err);
            });
            return deferred.promise;
        }

        this.resetPassword = function (resetPasswordInfo) {
            deferred = $q.defer();
            $http.post(serviceBase + "api/Account/profile_changePassword", resetPasswordInfo, {
            }).then(function (response) {
                deferred.resolve(response);
            })
            .catch(function (err, status) {
                deferred.resolve(err);
            });
            return deferred.promise;
        }

        this.getUpdateCCSignature = function () {
            deferred = $q.defer();
            $http.post(serviceBase + "api/subscription/getSignatureToUpdateCCDetails/", {
            }).then(function (response) {
                deferred.resolve(response);
            })
            .catch(function (err) {
                deferred.resolve(err);
            });

            return deferred.promise;
        }

        this.turnOnRecurringSubscription = function (data) {
            deferred = $q.defer();
            $http.post(serviceBase + "api/subscription/turnOnRecurringSubscription/", data, {
            }).then(function (response) {
                deferred.resolve(response);
            })
            .catch(function (err) {
                deferred.resolve(err);
            });

            return deferred.promise;
        }
    }
    ]);
})();